module.exports = __webpack_public_path__ + "media/images/flags/4x3/kgz-58c395a62befea51fe55f18ccae221ac.svg";